import { render } from "./EventArtists.vue?vue&type=template&id=56251c7e"
import script from "./EventArtists.vue?vue&type=script&lang=js"
export * from "./EventArtists.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__